import React from 'react';

import {translate} from 'iss/strings';
import dates from 'iss/utils/dates';
import {BatchOpFailure} from 'iss/widgets/batchOps/activation/BatchOpFailure';

export function listEventFailuresWithMessage(message) {
  const eventColumn = {
    header: translate('activationEditor.plannedDate'),
    cellProps: {className: "plannedDate" },
    accessor: ({event}) => dates.format(dates.fromJson(event.plannedDate)),
  };
  return (props) =>
    <BatchOpFailure message={message} extraColumns={[eventColumn]} {...props} />;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/batchOps/activation/BatchOpEventFailure.jsx